import React from "react";

const ExchangeSideBar = ({ Passenger, flatSegment }) => {
  return (
    <div className="hidden lg:block max-w-md w-full mx-auto mb-10 p-4 rounded-lg border border-black bg-white">
      <div>
        <h1 className="text-xl font-bold text-gray-800 mb-4">Passengers</h1>
        <div className="space-y-2">
          {Passenger?.map((passenger, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-2 bg-gray-50 hover:bg-gray-100 rounded-md"
            >
              <span className="text-lg font-medium text-gray-700">
                {index + 1}.
              </span>
              <div className="flex justify-between w-full">
                <p className="text-gray-800 font-semibold">
                  {passenger?.Name?.Given[0]?.value}{" "}
                  {passenger?.Name?.Surname?.value}
                </p>
                <p className="text-gray-800 font-semibold">
                  {passenger?.PTC?.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <h1 className="text-xl font-bold text-gray-800 mb-4">
          {" "}
          Flight Details
        </h1>
        <div className="space-y-2">
          {flatSegment?.map((segment, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-2 bg-gray-50 hover:bg-gray-100 rounded-md"
            >
              <span className="text-lg font-medium text-gray-700">
                {index + 1}.
              </span>

              <p className="text-gray-800 font-semibold">
                {segment?.From} <span className="text-gray-500">-</span>{" "}
                {segment?.To}
              </p>
              <p className="text-gray-800 font-semibold">
                {segment?.carrier} {segment?.FlightNumber}
              </p>
              <p className="text-gray-800 font-semibold">
                {segment?.ClassOfService} ({segment?.BookingClass})
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExchangeSideBar;
